export default __webpack_public_path__ + "static/media/g11.281bd5e8.jpg";